import React from 'react'
import CustomButton from "../../../../../src/components/custom/CustomButton";
import { Row, Form } from 'antd'

const customButton = ({ onCancel }) => {
    return (
        <Form.Item style={{ margin: 0, padding: 0 }}>
            <Row>
                <CustomButton
                    content="Submit"
                    style={{
                        width: "10%",
                        marginLeft: "auto",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                    htmlType="submit"
                    backgroundColor="#15CCAE"
                    colorText="black"
                    hoverBackground="#4FECA0"
                />
                <CustomButton
                    content="Cancel"
                    style={{
                        width: "10%",
                        marginLeft: "1%",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                    onClick={onCancel}
                />
            </Row>
        </Form.Item>
    )
}

export default customButton